import { Component, inject } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { faChevronDoubleLeft } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

const imports = [
	FontAwesomeModule,
	MatButton,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogTitle,
	TranslatePipe
];

@Component({
	selector: "lib-confirm-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrls: ["./_confirm-dialog.component.scss"],
	imports: imports
})
export class ConfirmDialogComponent {
	protected faChevronDoubleLeft = faChevronDoubleLeft;

	data = inject<{
		title: string;
		msg: string;
		no: string;
		yes: string;
		subMessage?: string;
		showBackButton?: boolean;
	}>(MAT_DIALOG_DATA);
}

@Component({
	selector: "lib-anamnese-confirm-leave-dialog",
	templateUrl: "./confirm-dialog.component.html",
	styleUrls: ["./_confirm-dialog.component.scss"],
	imports: imports
})
export class AnamneseConfirmLeaveDialogComponent {
	protected faChevronDoubleLeft = faChevronDoubleLeft;

	data = {
		title: "LeaveOrderConfirmationTitle",
		msg: "LeaveOrderConfirmationMessage",
		no: "LeaveOrderConfirmationNo",
		yes: "LeaveOrderConfirmationYes",
		subMessage: undefined,
		showBackButton: undefined
	};
}
